module.exports = __webpack_public_path__ + "static/media/exclamation-mark.9ee4db2a.svg";